import axiosInstance from "../axiosInstance";
import APIPaths from "../../utils/APIPaths";
import { toast } from "react-toastify";

export const putUpdateOrgDetails = async (bodyObj) => {
  const response = await axiosInstance
    .put(APIPaths.UPDATE_ORG, bodyObj, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      if (response.status === 200) {
        toast.success("Updated successfully.");
        return response;
      } else {
        toast.error("Something went wrong.");
        return null;
      }
    })
    .catch((error) => {
      toast.error(error.response.data);
      return null;
    });
  return response;
};

export const getOrgLogo = async (id) => {
  const response = await axiosInstance.get(`${APIPaths.GET_ORG_LOGO}${id}`, {
    responseType: "arraybuffer",
  });
  return response;
};

export const getOrgStamp = async (id) => {
  const response = await axiosInstance.get(`${APIPaths.GET_ORG_STAMP}${id}`, {
    responseType: "arraybuffer",
  });
  return response;
};

export const getOrgSign = async (id) => {
  const response = await axiosInstance.get(`${APIPaths.GET_ORG_SIGN}${id}`, {
    responseType: "arraybuffer",
  });
  return response;
};

export const getBusinessType = async () =>{
  const response = await axiosInstance.get(APIPaths.GET_BUSINESS_TYPE).then((response)=>{
    if(response.status === 200){
      return response.data;
    }
    return [] 
  }).catch((error)=>{
    toast.error(error.response.data)
    return [];
  })
  return response
} 